var React = require("react");

var ApplicationContext = require("../config/ApplicationContext.js");

var SiteHeader =         require("../controls/SiteHeader.jsx");
var Logins =             require("../controls/Logins.jsx");
var CarouselList =       require("../controls/CarouselList.jsx");
var DisplayAssetsHome =      require("../controls/DisplayAssetsHome.jsx");
var Footer =             require("../controls/Footer.jsx");
var Application =        require("../Application.js");
var ContentServerClient = require("../ContentServerClient.js");
var EditorLaunchUtil = require("../util/EditorLaunchUtil.js");

var MasterPage = require("./generic/MasterPage.jsx");


const SECTION_NAME = "home";

class Home extends React.Component {

    constructor() {
        super();

        this.onSearch = this.onSearch.bind(this);
        this.sendGoogleGA = this.sendGoogleGA.bind(this);
        this.onClickGetStarted = this.onClickGetStarted.bind(this);
        this.onClickPackageLink = this.onClickPackageLink.bind(this);
    }

    componentWillMount(){
        this.linkPackage = ApplicationContext.getPackageEditor();
        this.urlSignUp = `${ApplicationContext.adskAccountUrl}/register`;
    }

    componentDidMount() {
        document.title = "library.io";
        this.sendGoogleGA("home", "pageview");
    }

    onEdit(id, type = "library"){
        let base = type === "library" ? ApplicationContext.getPackageLibrary() : ApplicationContext.getPackageEditor();
        googleGA("send", "event", type, "edit");
        let win = window.open(EditorLaunchUtil.editorUrl(base, { id: id, mode: 2 }), '_blank');
        if (win) { win.focus() }
    }

    sendGoogleGA(page, type){
        googleGA("send", "event", page, type);
    }

    checkUserLoginThen(event, nextUrl) {
        Application.dataStore.checkUserLoginThen(nextUrl).then(succeed => {
            if(succeed) {
                this.props.history.push(nextUrl);
            }
        });
        event.preventDefault();
        event.stopPropagation();
    }

    onClickGetStarted(event) {
        var self = this;
        this.sendGoogleGA("home", "getstarted");
        this.checkUserLoginThen(event, "/start");
        return false;
    }

    onClickPackageLink(event){
        this.sendGoogleGA("home", "build");
        this.checkUserLoginThen(event, "/:idusername/packages");

        return false;
    }

    onSearch(value){
        this.props.history.push(`/search?q=${value}`);
    }


    render() {
        return (
            <MasterPage
                {...this.props}
                renderPage={addedProps =>
                    <div className="home">
                        <section className="hero ">
                            <div className="hero__clogin">
                                <SiteHeader type="Home" onSearch={this.onSearch}>
                                    <Logins onSendGoogleGA={this.sendGoogleGA} handleError={this.props.handleError}/>
                                </SiteHeader >
                            </div>
                            <div className="container">
                                <p className="hero__tagline">Datasheet to model in seconds</p>
                                <p className="hero__desc">Parametric ECAD - MCAD content generation online</p>
                                <button className="hero__try button" onClick={this.onClickGetStarted}>Get Started</button>
                            </div>
                        </section>
                        <CarouselList onSendGoogleGA={this.sendGoogleGA} />
                        <div className="callout">
                            <div className="container">
                                <h1 className="callout__head"></h1>
                                <p className="callout__text">Use library.io with Autodesk Fusion to build your next PCB.</p>
                                <a className="button callout__button" href="https://www.autodesk.com/products/fusion-360/overview" onClick={() => this.sendGoogleGA("home", "tryFusion")} target="_blank">Download Now</a>
                            </div>
                        </div>
                        <section className="intro">
                            <DisplayAssetsHome history={this.props.history} handleError={this.props.handleError}/>
                        </section>
                        <section className="close">
                            <div className="container">
                                <h1 className="close__head">Start building with library.io today!</h1>
                                <a href="/start" className="hero__try button" onClick={this.onClickGetStarted}>Get Started</a>
                            </div>
                        </section>

                        <Footer type={SECTION_NAME}/>
                    </div>
                }
            />
        );
    }


}


module.exports = Home;
